import React, { ReactElement, ReactNode } from "react"
import { Box, Flex, Text } from "@chakra-ui/react"
import EventResourceListItem from "./layout/EventResourceListItem"
import Icon from "./elements/Icon"
import Pill from "./elements/Pill"

type Props = {
  id: string
  selectedListItemId: string
  path: string
  icon: string | ReactElement
  title: string
  sentOn: string|null
  subtitle?: string|null
  sendScheduledAt?: string|null
  endIcon?: ReactNode
  hideStatus?: boolean
}

const EventResourcesViewListItem = ({
  id, selectedListItemId, path, icon, title, subtitle,
  sentOn, sendScheduledAt, endIcon, hideStatus = false,
}: Props) => {
  const iconElement = typeof icon === "string"
    ? <Icon icon={icon} size={8} mr={5} />
    : <Box mr={5}>{icon}</Box>

  return (
    <EventResourceListItem key={id} selected={id === selectedListItemId} path={path}>
      <Flex align="center" mr={5}>
        {iconElement}
        <Box>
          <Text fontSize="lg" noOfLines={1}>{title}</Text>
          {subtitle && <Text fontSize="sm">{subtitle}</Text>}
        </Box>
      </Flex>
      <Flex align="center" gap={2}>
        {endIcon}
        {!hideStatus && <StatusPill sentOn={sentOn} sendScheduledAt={sendScheduledAt} />}
      </Flex>
    </EventResourceListItem>
  )
}

type StatusPillProps = {
  sentOn: string|null
  sendScheduledAt?: string|null
}
const StatusPill = ({ sentOn, sendScheduledAt }: StatusPillProps) => {
  if (sentOn) {
    return <Pill label="Sent" color="blue.400" px={2} />
  }

  if (sendScheduledAt) {
    return <Pill label="Scheduled" color="purple.400" width="auto" px={4} />
  }

  return <Pill label="Draft" color="gray.400" px={2} />
}

export default EventResourcesViewListItem
